import React from 'react'
import { Provider } from 'react-redux'
import { model } from '@src/mirrorx'
import onlineApplicationModel from '@src/model/online-application-model'
import mainModel from '@src/model/main-model'
import { options } from '@src/mirrorx/defaults'
import { createStore } from '@src/mirrorx/store'
import { models } from '@src/mirrorx/model'

model(onlineApplicationModel)
model(mainModel)

export default ({ element }) => {
  const { initialState, middlewares, reducers } = options
  const store = createStore(models, reducers, initialState, middlewares)

  return (
    <Provider store={store}>
      {element}
    </Provider>
  )
}
